(function () {
  const REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const REVEAL_SELECTOR = [
    '.ecome-home__hero-grid',
    '.ecome-home__platform-strips',
    '.ecome-home__choose',
    '.ecome-home__one-time',
    '.ecome-home__deal-row',
    '.ecome-home__promo-triple',
    '.ecome-home__trust-strip',
    '.ecome-home__offers-carousel',
    '.ecome-home__products-carousel',
    '.product-digital-hub__card',
    '.product-digital-hub__cross-card',
    '.cart-page__items-panel',
    '.cart-page__summary'
  ].join(',');
  const PRESSABLE_SELECTOR = '.button, .ecome-home__card, .product-digital-hub__cross-card, .cart-items__table-row';

  let revealObserver = null;
  const initializedRevealNodes = new WeakSet();
  const initializedPressNodes = new WeakSet();

  function getRevealObserver() {
    if (revealObserver || REDUCED_MOTION || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    return revealObserver;
  }

  function initReveal(root) {
    const nodes = root.querySelectorAll(REVEAL_SELECTOR);
    if (!nodes.length) return;

    const observer = getRevealObserver();
    let localIndex = 0;

    nodes.forEach((node) => {
      if (initializedRevealNodes.has(node)) return;
      initializedRevealNodes.add(node);

      node.setAttribute('data-anubis-reveal', '');
      node.style.setProperty('--anubis-reveal-delay', `${Math.min(localIndex * 35, 220)}ms`);
      localIndex += 1;

      if (REDUCED_MOTION || !observer) {
        node.classList.add('is-visible');
      } else {
        observer.observe(node);
      }
    });
  }

  function bindPressState(node) {
    if (initializedPressNodes.has(node)) return;
    initializedPressNodes.add(node);

    const pressOn = () => node.classList.add('is-pressing');
    const pressOff = () => node.classList.remove('is-pressing');

    node.addEventListener('pointerdown', pressOn, { passive: true });
    node.addEventListener('pointerup', pressOff, { passive: true });
    node.addEventListener('pointercancel', pressOff, { passive: true });
    node.addEventListener('pointerleave', pressOff, { passive: true });
    node.addEventListener('blur', pressOff, true);
  }

  function initPressState(root) {
    if (REDUCED_MOTION) return;
    const pressables = root.querySelectorAll(PRESSABLE_SELECTOR);
    pressables.forEach(bindPressState);
  }

  function bootstrap(root) {
    initReveal(root);
    initPressState(root);
  }

  document.addEventListener('DOMContentLoaded', () => bootstrap(document));
  document.addEventListener('shopify:section:load', (event) => bootstrap(event.target || document));
})();
